export default "__VITE_ASSET__DnQiSdcy__"